<template>
  <CBottomPopup
    v-model="shown"
    title="申请退款"
    max-height="100%"
    :close-on-click-overlay="false"
    @closed="onClosed"
  >
    <div class="refund-drawer">
      <div class="refund-form-item">
        <CLabel required>退款金额</CLabel>
        <CInput v-model="amount" type="number" placeholder="¥ 请输入退款金额" />
      </div>
      <div class="refund-form-item">
        <CLabel required>退款理由</CLabel>
        <CInput v-model="comment" placeholder="请输入退款理由" />
      </div>
      <div class="refund-form-item">
        <CLabel required>附件 (图片格式，至少上传一张图)</CLabel>
        <div>
          <ImageUploader v-model="images" :max-count="9"></ImageUploader>
        </div>
      </div>
      <div class="flex" style="margin-top: 75px">
        <CButton :disabled="confirmDisabled" primary @click="onConfirm"
          >确定</CButton
        >
      </div>
    </div>
  </CBottomPopup>
</template>

<script>
import CBottomPopup from "@/components/common/CBottomPopup.vue";
import CButton from "@/components/common/CButton.vue";
import CInput from "@/components/common/CInput.vue";
import CLabel from "@/components/common/CLabel.vue";
import ImageUploader from "@/components/common/ImageUploader.vue";

export default {
  components: { CBottomPopup, CLabel, CInput, ImageUploader, CButton },
  data() {
    return {
      shown: false,
      maxAmount: 0,
      amount: "",
      comment: "",
      images: [],
    };
  },
  computed: {
    confirmDisabled() {
      return (
        !this.amount ||
        !this.comment ||
        !this.images.filter(({ filename, deleted }) => filename && !deleted)
          .length
      );
    },
  },
  methods: {
    show({ maxAmount }) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
        this.maxAmount = maxAmount;
        this.shown = true;
      });
    },
    onClosed() {
      if (this._reject) {
        this._reject();
        this._resolve = null;
        this._reject = null;
      }
      this.amount = "";
      this.comment = "";
      this.images = [];
    },
    onConfirm() {
      const { amount, comment, images } = this;
      if (!/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(String(amount).trim())) {
        this.$toast("请正确输入金额");
        return;
      }
      if (Number(amount) == 0) {
        this.$toast("退款金额不能为0");
        return;
      }
      if (Number(amount) > this.maxAmount) {
        this.$toast("退款金额大于付款总额");
        return;
      }
      if (this._resolve) {
        // console.log("onConfirm", { amount, comment, images });
        this._resolve({
          amount,
          comment,
          attachments: JSON.stringify(
            images
              .filter(({ filename, deleted }) => filename && !deleted)
              .map(({ filename }) => filename)
          ),
        });
        this._resolve = null;
        this._reject = null;
      }
      this.shown = false;
    },
  },
};
</script>

<style lang="less" scoped>
.refund-drawer {
  width: 100vw;
  min-height: 100/20rem;
  padding: 8/20rem 20/20rem 20/20rem;
  .refund-form-item {
    margin-bottom: 12/20rem;
  }
}
</style>
